import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import setWrappedDisplayName from 'decorators/setWrappedDisplayName';
import { setLocation } from 'utils/helpers';
import {
	trackContactLinkClick,
	trackOutboundLinkClick,
} from './clickTrackingUtils';

const enhance = (Component) => {
	const WithClickTracking = ({ onClick = noop, ...props }) => {
		const handleClick = (evt) => {
			const { href, target } = props;

			if (href && target !== '_blank') {
				evt.preventDefault(evt);
				setLocation(href);

				const isTelTag = href.includes('tel:');
				const isMailTag = href.includes('mailto:');

				if (isTelTag || isMailTag) {
					const { target } = evt;
					const { id, className, innerText } = target;

					let tagType = isTelTag ? 'tel' : 'mailto';

					trackContactLinkClick(
						id || className,
						innerText,
						innerText,
						tagType,
					);
				}
			} else if (href && target.includes('blank')) {
				const { target } = evt;
				const { id, innerText } = target;

				trackOutboundLinkClick(
					id || 'outbound-link',
					innerText,
					innerText,
					href,
				);
			}

			Promise.resolve(onClick(evt));
		};

		return (
			<Component
				{...props}
				onClick={onClick}
				handleClick={handleClick}
			/>
		);
	};
	WithClickTracking.propTypes = {
		onClick: PropTypes.func,
		href: PropTypes.string,
		target: PropTypes.string,
	};
	return setWrappedDisplayName('SegmentClickTracking')(WithClickTracking);
};

export default enhance;
